// extracted by mini-css-extract-plugin
export default {"videoBlock":"Player_videoBlock__B6w2O"};